'use client';

import React, { useState } from 'react';
import { Case, Default, Switch } from 'react-if';
import { toastr } from 'react-redux-toastr';

import { Button } from '@nerdwallet/currency/components/Button';
import { Type } from '@nerdwallet/currency/components/Type';
import { InputEmail } from '@nerdwallet/currency/components/InputEmail';

import CsrfSession from '@components/csrf-session';
import PageImpression from '@components/page-impression';
import nwApiSDK from '@lib/nw-api-sdk';
import { isEmailValid } from '@lib/utils/email';

import styles from './forgot-password.module.scss';

const { IdentitySDK } = nwApiSDK;
const EMAIL_ERROR_MESSAGE = 'Please enter a valid email address';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [emailValid, setEmailValid] = useState(true);

  const handleInputChange = (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail);

    const isValid = isEmailValid(newEmail);
    setEmailValid(isValid);
  };

  const handleFormSubmission = (event) => {
    event.preventDefault();

    if (emailValid) {
      IdentitySDK.sendPasswordResetEmail(
        email,
        IdentitySDK.PASSWORD_RESET_URLS.MY_NERDWALLET,
      )
        .then(() => {
          setEmailSent(true);
        })
        .catch((error) => {
          toastr.error(
            '',
            error?.resp?.data?.error?.data?.internal_message ||
              'Please try again later.',
          );
        });
    }
  };

  return (
    <CsrfSession>
      <PageImpression entityName="onboarding_forgot_password">
        <div className={styles.container}>
          <div className={styles.contentContainer}>
            <div className={styles.headingContainer}>
              <Type>Reset your password</Type>
            </div>
            <Switch>
              <Case condition={!emailSent}>
                <form onSubmit={handleFormSubmission}>
                  <div className={styles.formContainer}>
                    <InputEmail
                      error={!emailValid}
                      errorMessage={EMAIL_ERROR_MESSAGE}
                      fullWidth
                      label="Email address"
                      onChange={handleInputChange}
                      value={email}
                    />
                    <div className={styles.buttonContainer}>
                      <Button type="submit" primary>
                        Send reset email
                      </Button>
                    </div>
                  </div>
                </form>
              </Case>
              <Default>
                <div className={styles.confirmationContainer}>
                  An email with instructions to reset your password has been
                  sent to {email}.
                </div>
              </Default>
            </Switch>
          </div>
        </div>
      </PageImpression>
    </CsrfSession>
  );
};

ForgotPassword.displayName = 'ForgotPassword';

export default ForgotPassword;
